import { PHYSICAL_EXAM_SECTION_INITIAL_VALUES } from "./physical-exams";

export const SKIN_FORM_INITIAL_VALUES = {
  sections: {
    skin: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type PhysicalExamSkinSections = keyof typeof SKIN_FORM_INITIAL_VALUES.sections;
